import {Reactor} from 'championship/src/classes/utils/reactor'
// import 'championship/src/functions/polyfills'
import 'championship/src/polyfills/String.padStart'

class RangedDigitalMaskedInputChunk{
    constructor(options){
        this.id = options.id
        this.content = options.content
    }
    updatePosition(position){
        this.current_position = position
    }
    isSubstitutable(){
        return false
    }
    getContent(){
        return this.content
    }
}
Reactor.Trait(RangedDigitalMaskedInputChunk)

class RangedDigitalMaskedInputChunkSubstitution extends RangedDigitalMaskedInputChunk{
    constructor(options){
        super(Object.assign({}, {
            content: '',
        }, options))
        this.placeholder = options.placeholder
        this.range_mask = options.range_mask
        this.content = this.placeholder
        this.need_pad = options.need_pad || false
        this.current_value = ''
        this.parseRange()
        this.registerEvents('overflowed', 'flushed')
    }
    parseRange(){
        const parsed_range = this.range_mask.match(/(\d+)\-(\d+)/)
        this.min = Number(parsed_range[1])
        this.max = Number(parsed_range[2])
    }
    isSubstitutable(){
        return true
    }
    prepareContent(){
        if(this.current_value){
            this.content = this.current_value
        }else{
            this.content = this.placeholder
        }
    }
    getCursorShift(){
        return this.current_value.length
    }
    apply(key){
        if(this.handleOverflowed()){
            return
        }

        let concated = this.current_value.concat(key)

        if(Number(concated) > this.max){
            concated = this.max.toString()
        }

        if(this.current_value.length != concated.length){
            this.current_value = concated
        }

        if(this.handleOverflowed()){
            if (Number(this.current_value) < this.min){
                this.current_value = this.min.toString()
                if(this.need_pad){
                    this.current_value = this.current_value.padStart(this.max.toString().length,'0')
                }
            }            
        }
        this.prepareContent()
    }
    flush(direction){
        if(direction < 0){
            this.current_value = this.current_value.slice(0, this.current_value.length-1)
        }else if (direction > 0){
            this.current_value = this.current_value.slice(1, this.current_value.length)
        }

        if(!this.current_value){
            this.dispatchEvent('flushed', {sender: this})
        }

        this.prepareContent()
    }
    handleOverflowed(){
        if(this.current_value.length >= this.max.toString().length){
            this.dispatchEvent('overflowed', {sender: this})
            return true
        }
    }
}

class RangedDigitalMaskedInput{
    constructor(node, options){
        this.node = node
        this.mask = options.mask
        this.need_pad = options.pad || false

        this.parseMask()
        this.initActions()
    }
    parseMask(){
        this.chunks = []
        let current_read_index = 0

        const matches = this.mask.matchAll(/\<\<(.*?)\>\>/g)
        for(const _match of [...matches]){
            const sample = _match[0]
            const range = _match[1]
            const parsed_range = range.match(/(\d+)\-(\d+)/)

            if(_match.index - current_read_index > 0){
                this.chunks.push(new RangedDigitalMaskedInputChunk({
                    id: this.chunks.length,
                    content: this.mask.substr(
                        current_read_index, 
                        _match.index - current_read_index
                    )
                }))
            }
            
            if(parsed_range){
                const chunk = new RangedDigitalMaskedInputChunkSubstitution({
                    id: this.chunks.length,
                    sample: sample,
                    range_mask: range,
                    placeholder: '__',
                    need_pad: this.need_pad,
                })
                chunk.addEventListener('overflowed', this.onChunkOverflowed.bind(this))
                chunk.addEventListener('flushed', this.onChunkFlushed.bind(this))
                this.chunks.push(chunk)

            }else{
                throw new Error(`Invalid range passed: ${range}`)
            }
            current_read_index = _match.index + sample.length
        }

        if(current_read_index < this.mask.length){
            this.chunks.push(new RangedDigitalMaskedInputChunk({
                id: this.chunks.length,
                content: this.mask.substr(
                    current_read_index, 
                    this.mask.length - current_read_index
                )
            }))
        }

        this.glue()
    }
    glue(){
        let value = ''
        for(const chunk of this.chunks){
            value += chunk.getContent()
        }
        this.node.value = value
    }
    initActions(){
        this.node.addEventListener('keydown', this.onKeyDown.bind(this))
        this.node.addEventListener('click', this.onFocus.bind(this))
    }
    onKeyDown(event){

        console.log('onKeyDown')
        event.preventDefault()
        if(event.key == 'Delete'){
            this.flushKey(1)
        }else if(event.key == 'Backspace'){
            this.flushKey(-1)
        }else{
            this.tryKey(event.key)
        }
        this.handleCursor()
        return false
    }
    onChunkOverflowed(event){
        // console.log(event)
        this.picked_chunk = this.findNearestSubstitution(event.args.sender.id+1, 1)
    }
    onChunkFlushed(event){
        // console.log(event)
        this.picked_chunk = this.findNearestSubstitution(event.args.sender.id-1, -1)
    }
    flushKey(direction){
        if(this.picked_chunk.isSubstitutable()){
            this.picked_chunk.flush(direction)
            this.glue()

            this.node.dispatchEvent(new Event('ranged_mask.changed'))
        }
    }
    tryKey(key){
        if(/^\d+$/.test(key) && this.picked_chunk.isSubstitutable()){
            this.picked_chunk.apply(key)
            this.glue()

            this.node.dispatchEvent(new Event('ranged_mask.changed'))
        }
    }
    onFocus(event){
        let picked_position = this.node.selectionStart
        this.setCursorInSubstitutionFrom(picked_position)
    }
    handleCursor(){
        if(this.picked_chunk){
            const shift = this.picked_chunk.getCursorShift()
            this.node.setSelectionRange(
                this.picked_chunk.current_position + shift,
                this.picked_chunk.current_position + shift
            )
        }
    }
    setCursorInSubstitutionFrom(picked_position){
        let current_index_start = 0

        for(const [i, chunk] of this.chunks.entries()){
            if(
                picked_position >= current_index_start 
                && picked_position <= current_index_start + chunk.content.length
            ){
                this.picked_chunk = chunk
            }
            chunk.updatePosition(current_index_start)
            current_index_start += chunk.content.length
        }

        if(! this.picked_chunk.isSubstitutable()){
            this.picked_chunk = this.findNearestSubstitution(this.picked_chunk.id)
        }

        this.node.setSelectionRange(
            this.picked_chunk.current_position,
            this.picked_chunk.current_position
        )
    }
    findNearestSubstitution(index, direction = 1){
        let found_chunk = null

        if(direction > 0){
            if(index+1 < this.chunks.length && this.chunks[index+1].isSubstitutable()){
                found_chunk = this.chunks[index+1]
            } else if(index-1 >= 0 && this.chunks[index-1].isSubstitutable()){
                found_chunk = this.chunks[index-1]
            }
        }else if(direction < 0){
            if(index-1 >= 0 && this.chunks[index-1].isSubstitutable()){
                found_chunk = this.chunks[index-1]
            }else if(index+1 <= this.chunks.length && this.chunks[index+1].isSubstitutable()){
                found_chunk = this.chunks[index+1]
            }
        }

        return found_chunk
    }
}

export {
    RangedDigitalMaskedInput
}